import { useEffect, useState } from "react";
import { Heart, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useI18n } from "@/lib/i18n.jsx";
import { isHealthKitEnabled, isHealthKitAvailable } from "@/lib/healthkit";
import { toggleHealthKitConnection, isHealthKitConnected } from "@/components/HealthKitStepsSync";

// Inline "Connect Apple Health" row inside the Dashboard steps card (iOS only, until connected).
export default function HealthKitConnectInline({ onConnected }) {
  const { lang } = useI18n();
  const en = lang === "en";
  const [visible, setVisible] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    if (!isHealthKitEnabled() || isHealthKitConnected()) return;
    isHealthKitAvailable().then((ok) => alive && setVisible(ok));
    return () => { alive = false; };
  }, []);

  if (!visible) return null;

  const connect = async () => {
    setBusy(true);
    try {
      if (await toggleHealthKitConnection(true)) {
        toast.success(en ? "Connected to Apple Health" : "تم الاتصال بـ Apple Health");
        setVisible(false);
        onConnected?.();
      } else {
        toast.error(en ? "Couldn't connect — allow Calofay in the Health app" : "تعذّر الاتصال — اسمح لكالوفاي في تطبيق الصحة");
      }
    } finally { setBusy(false); }
  };

  return (
    <div className="mt-3 flex items-center gap-3 bg-rose-50 border border-rose-100 rounded-2xl p-3" data-testid="healthkit-inline-connect">
      <div className="w-9 h-9 rounded-xl bg-white flex items-center justify-center flex-shrink-0">
        <Heart className="w-4 h-4 text-rose-500" fill="currentColor" />
      </div>
      <div className="flex-1 min-w-0 text-start">
        <div className="text-[13px] font-bold text-neutral-900">{en ? "Sync steps from Apple Health" : "زامن خطواتك من Apple Health"}</div>
        <div className="text-[11px] text-neutral-500 leading-snug">{en ? "Automatic every day, including past days" : "تلقائياً كل يوم، وحتى الأيام السابقة"}</div>
      </div>
      <button
        onClick={connect}
        disabled={busy}
        className="bg-rose-500 text-white text-xs font-bold px-4 py-2 rounded-full flex-shrink-0 active:scale-95 disabled:opacity-60"
        data-testid="healthkit-inline-connect-btn"
      >
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : (en ? "Connect" : "تفعيل")}
      </button>
    </div>
  );
}
